import r from"moment";var m=function(m,n){var o=r(m),t=r(n||r());return r.duration(o.diff(t)).humanize({s:60,m:60,h:24,d:7,w:4,M:12})};export{m as timeAgoCalculator};
//# sourceMappingURL=time.js.map
